/**
 * Campos do `ProcessoDTO` real (confirmados via `pesquisarProcessos.controller.jsx`,
 * usado pela tela real `PesquisarProcessosPage.jsx`) com correspondência direta na
 * grid do protótipo. `nroProcesso` alimenta duas chaves de saída: `id` (convenção da
 * tela real — não existe id numérico separado) e `nroProcesso` (exibição).
 */
const CAMPOS_PROCESSO_PARA_GRID = {
  valorProcesso: 'valorPrincipal',
  corAlertaFase: 'corAlertaFase',
  qtdeDiasFaseAtual: 'diasFase',
  naoTrabalhado: 'naoTrabalhado',
  pasta: 'pasta',
  nomeRequisicao: 'requisicao',
  nomeNegociador: 'negociador',
  nomeDevedor: 'nomeDevedor',
  nomeCliente: 'nomeCliente',
  nomeFase: 'fase',
  tituloAgendamento: 'tituloAgendamento',
  descricaoStatusProcesso: 'status',
};

/** Normaliza o enum real (prefixo `COMPROMISSO_`) para o enum já usado por `AlertasProcesso.jsx`. */
const COMPROMISSO_NORMALIZADO = {
  COMPROMISSO_EXPIRADO: 'EXPIRADO',
  COMPROMISSO_EXPIRACAO_PROXIMA: 'EXPIRACAO_PROXIMA',
  COMPROMISSO_MARCADO: 'MARCADO',
  DISABLED: 'DISABLED',
};

/**
 * Campos sem fonte confirmada no `ProcessoDTO` real — valor fixo para todo processo
 * nesta entrega (decisão validada com o usuário, ver plano AW2-913, Etapa 3).
 * `status` saiu desta lista — fonte confirmada em `descricaoStatusProcesso`
 * (ver `CAMPOS_PROCESSO_PARA_GRID` acima).
 */
const PLACEHOLDERS_SEM_FONTE_CONFIRMADA = {
  situacao: 'SEM_PRAZO',
  condicao: null,
  dataAbertura: null,
};

function normalizarCompromisso(compromisso) {
  return COMPROMISSO_NORMALIZADO[compromisso] ?? null;
}

function mapearProcesso(processo) {
  const linha = {
    id: processo.nroProcesso,
    nroProcesso: processo.nroProcesso,
    ...PLACEHOLDERS_SEM_FONTE_CONFIRMADA,
  };
  Object.entries(CAMPOS_PROCESSO_PARA_GRID).forEach(([campoOrigem, campoDestino]) => {
    linha[campoDestino] = processo[campoOrigem];
  });
  linha.compromisso = normalizarCompromisso(processo.compromisso);
  return linha;
}

/**
 * Traduz `state.pesquisaProcessosUnificada.resultado` (array de `ProcessoDTO` real)
 * para o shape que `GridProcessos.jsx`/`AlertasProcesso.jsx` já sabem renderizar.
 *
 * Fail-closed por construção: só os campos explicitamente mapeados acima saem —
 * nenhum campo do `ProcessoDTO` real vaza sem passar por esta tabela (mesmo
 * princípio de `pesquisaProcessosPage.mapper.js`).
 *
 * @param {?Array<Object>} resultado - array de `ProcessoDTO`, ou `null`/`undefined`
 *   quando nenhuma pesquisa foi feita ainda.
 * @returns {Array<Object>} linhas no shape de `GridProcessos.jsx`; `[]` se `resultado`
 *   for `null`/`undefined`.
 */
export function mapearResultadoParaGrid(resultado) {
  if (!resultado) return [];
  return resultado.map(mapearProcesso);
}
